import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useWebhookMutations from "../../datahooks/useWebhookMutations";

import type { Webhook } from "../../types";

interface DeleteWebhookProps {
  webhook: Webhook;
  onBack: () => void;
  onSuccess: () => void;
}

export default function DeleteWebhook({
  webhook: { id, name },
  onBack,
  onSuccess,
}: DeleteWebhookProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteWebhook, isDeletingWebhook } = useWebhookMutations();

  function onDelete() {
    deleteWebhook({ webhookId: id }).then(() => onSuccess());
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Delete webhook</Title>
      <Description className="mb-8">
        Are you sure you want to delete{" "}
        <span className="break-words font-semibold text-black-950">{name}</span>
        ?
      </Description>
      <div className="flex justify-between gap-2.5">
        <Button
          variant="secondary-black"
          onClick={onBack}
          disabled={isDeletingWebhook}
          className="lg:flex-1"
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          isLoading={isDeletingWebhook}
          className="lg:flex-1"
          onClick={onDelete}
        >
          Delete
        </Button>
      </div>
    </>
  );
}
